'use client';

import React from 'react';

import styles from './MainColumn.module.css';

interface Props {
  className?: string;
  children: React.ReactNode;
}

const MainColumn = ({ children, className }: Props) => {
  return (
    <div className={`${styles.mainColumn} ${className || ''}`}>
      {children}
    </div>
  );
};

export default MainColumn;
